import { Button } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LayoutContainer } from "../../components/layoutContainer";
import { usePhoneConfirmationContext } from "../../context/PhoneConfirmationContext";
import { useCountryStore } from "../../stores/useCountry";
import styles from "./styles.module.scss";

export default function SuccessPage() {
  const { country } = useCountryStore();
  const { t } = useTranslation();

  const { message } = usePhoneConfirmationContext();

  const getDeezerActivationLink = () => {
    switch (country) {
      case "CO":
        return "https://www.deezer.com/es/activate/playhubco";
      case "PE":
        return "https://www.deezer.com/es/activate/playhubpe";
      case "EC":
        return "https://www.deezer.com/es/activate/playhubec";
      case "BR":
      default:
        return "https://www.deezer.com/br/activate/playhubbr";
    }
  };

  const handleComeback = () => {
    window.location.href = "/";
  };

  useEffect(() => {
    if (message === "") {
      window.location.href = "/";
    }
  }, []);

  return (
    <LayoutContainer>
      <div className={styles.container}>
        <div className={styles.texts}>
          <h5>{t("numberConfirmedTitle")}</h5>
          <h6>
            {t("numberConfirmedDescription_before")}{" "}
            <strong>Deezer Premium</strong>{" "}
            {t("numberConfirmedDescription_after")}{" "}
            <a
              href={getDeezerActivationLink()}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("clickHere")}
            </a>
            .
          </h6>
        </div>
        <div>
          <Button type="submit" onClick={handleComeback} fullWidth>
            {t("backButtonLabel")}
          </Button>
        </div>
      </div>
    </LayoutContainer>
  );
}
